import { AxiosResponse } from "axios";
import React from "react";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import { MultiPickerListProps } from "../props";
import { LinkedBookkeepingPanelInstructionBase } from "./model";
import { BookkeepingListItem } from "./MultiBookkeepingList";

interface Props<T extends LinkedBookkeepingPanelInstructionBase> extends MultiPickerListProps<server.dto.BookkeepingSmall> {
  initialInstruction: T;
  listFunc: (instruction: T) => Promise<AxiosResponse<server.dto.ApiResponseWrapperWithRequest<server.dto.BookkeepingSmall[], server.dto.ListLinkedBookkeepingFilters>, any>>;
}

const MultiLinkedBookkeepingList = <T extends LinkedBookkeepingPanelInstructionBase>(props: Props<T>) => {
  const [instruction, setInstruction] = React.useState<T>({
    page: 1,
    perPage: 20,
    keyword: undefined,
    ...props.initialInstruction,
  });

  return <>
    <MultiPickerListWithSelectedItems
      instruction={instruction}
      onInstructionChange={i => setInstruction(i)}
      queryKey="linkedbookkeepingpickerlist"
      api={props.listFunc}

      getError={() => undefined}
      excludeKeys={props.excludeKeys}

      onChange={props.onChange}
      renderListItem={BookkeepingListItem}
      getId={bk => bk.bookkeepingId}
      getLabel={BookkeepingListItem}
      value={props.value}
    />
  </>;
};

export default MultiLinkedBookkeepingList;